export const MIXPANEL_EVENT_TYPES = {
    STANDARD: 'standard',
    PAGE_VIEW: 'page_view'
};
